import FeedbackListContainer from '../../containers/admin/FeedbackListContainer';

export default function AdminFeedbackPage() {
    return (
        <FeedbackListContainer />
    );
}
